import { SearchByLocation } from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.SEARCHBYLOCATION.path,
      name: "Search By Location",
      key: routesMap.SEARCHBYLOCATION.path,
      commonRoute: true,
      private: false,
      // withAuth: true,
      // belongsToHeader: true,
      element: <SearchByLocation />,
    }
  ];
}
